import { createContext, useContext } from "react"

import { ProductQuickInfos } from "entities/products/types/QuickInfos"

export interface ProductQuickInfosContextValue {
  quickInfos: ProductQuickInfos | undefined
  copyToClipboard: () => void
}

export const ProductQuickInfosContext =
  createContext<ProductQuickInfosContextValue | null>(null)

export function useProductQuickInfosContext(): ProductQuickInfosContextValue {
  const ctx = useContext(ProductQuickInfosContext)
  if (!ctx) {
    throw new Error(
      "useProductQuickInfosContext must be used within ProductQuickInfos.Root"
    )
  }
  return ctx
}
